/* fdp-price.js (T4a): the price engine. Pure functions over the #fdp-prices tables (gen-price-tables).
   A port of the approved mockup's engine (mockup/page.html, the pricing block), with D. -> T., plus the
   two deliberate changes of PLAN 6.4 (sizeGroups ends a group at a missing size; basePrice is the
   cheapest group) and names & numbers as a flat per-piece add (PLAN 14.1: eachAt(gp + nn, dec, q)).
   Money is in dollars; cents only through Math.round(x * 100). view(mode, state) returns exactly the
   HTML that snippets/gen-price.liquid prints for the same state, so the page reads the same before and
   after this script (tools/theme_price_check.py compares them).
   Dec = {method: "print", spots: [front, back, sleeve]} | {method: "emb", size: "small" | "large"}.
   No decoration, no price (2026-10-28): a print Dec with no spot that has colors has no price at all. decoAt and
   eachAt return NaN for it, money(NaN) is "", and view() prints nothing for each / total / second / terms /
   headline / strip / cliff, exactly as gen-price.liquid does, so a blank-garment price can never be shown.
   Piece counts read with thousands commas ("1,000–2,499", "Order 2,500 instead"), as gen-price's labels. */
(function () {
  "use strict";
  if (window.FDP && window.FDP.price) return;
  var FDP = window.FDP = window.FDP || {};

  var T = null;
  var c2 = function (x) { return Math.round(x * 100) / 100; };
  var need = function () {
    if (!T && !load()) throw new Error("FDP.price: no #fdp-prices tables on this page");
    return T;
  };

  function valid(t) {
    return !!(t && typeof t.v === "string" && Array.isArray(t.tiers) && t.tiers.length > 1 && Array.isArray(t.print) &&
      t.print.length === t.tiers.length && Array.isArray(t.extra_spot) && t.emb && t.emb.small && t.emb.large && t.from);
  }

  function load(tables) {
    var t = tables;
    if (!t) {
      var el = document.getElementById("fdp-prices");
      if (el) { try { t = JSON.parse(el.textContent); } catch (e) { t = null; } }
    }
    if (!valid(t)) { T = null; api.ready = false; api.T = null; api.v = null; return false; }
    T = t; api.ready = true; api.T = t; api.v = t.v;
    return true;
  }

  function money(x) {
    if (typeof x !== "number" || !isFinite(x)) return "";   // never "$NaN": no price is printed instead
    var c = Math.round(x * 100), neg = c < 0;
    if (neg) c = -c;
    var d = Math.floor(c / 100), r = c % 100;
    return (neg ? "-" : "") + "$" + String(d).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + (r < 10 ? "0" : "") + r;
  }

  // ---- the mockup's engine (lines 844-872), D. -> T. ----
  var tierOf = function (q) { var i = 0; need().tiers.forEach(function (t, k) { if (q >= t.min) i = k; }); return i; };
  // 1000 -> "1,000" (gen-price's qty_text)
  var qtyText = function (n) { return String(Math.floor(+n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ","); };
  var tierLabel = function (i) { var t = need().tiers[i]; return t.max ? qtyText(t.min) + "–" + qtyText(t.max) : qtyText(t.min) + "+"; };
  // The spot with the most ink colors pays its full tier price; every other spot two-thirds of its own (owner 2026-10-28).
  function decoAt(dec, i) {
    need();
    if (dec.method === "emb") return T.emb[dec.size].per_piece[i];
    var n = T.extra_spot[0], d = T.extra_spot[1];
    var spots = (dec.spots || []).filter(function (c) { return c > 0; }).map(function (c) { return Math.min(c, 6); });
    if (!spots.length) return NaN;   // no spot with colors: no decoration, so no price (never a blank-garment price)
    return spots.sort(function (a, b) { return b - a; })
      .reduce(function (a, c, k) { return a + (k === 0 ? T.print[i][c - 1] : c2(T.print[i][c - 1] * n / d)); }, 0);
  }
  var eachAt = function (gp, dec, q) { return c2(gp + decoAt(dec, tierOf(q))); };
  function cliff(gp, dec, q) {
    // the next tier that is actually cheaper (embroidery 24-49 and 50-99 cost the same)
    var cur = eachAt(gp, dec, q), i = tierOf(q);
    if (!isFinite(cur)) return null;
    var j = T.tiers.findIndex(function (t, k) { return k > i && eachAt(gp, dec, t.min) < cur; });
    if (j < 0) return null;
    var m = T.tiers[j].min, now = c2(q * cur), then = c2(m * eachAt(gp, dec, m));
    return then < now ? { chip: true, m: m, then: then, save: c2(now - then) } : { chip: false, m: m, each: eachAt(gp, dec, m) };
  }
  // Sizes that share a garment price, in order. prices aligned to sizes; null = size not made, and a gap
  // ends the group, so [19.71, null, 19.71] reads "XS" and "M", never "XS–M" (PLAN 6.4 change 1).
  function sizeGroups(sizes, prices) {
    var out = [], last = null;
    sizes.forEach(function (s, k) {
      var p = prices[k];
      if (p == null) { last = null; return; }
      if (last && last.price === p) last.to = s; else { last = { from: s, to: s, price: p }; out.push(last); }
    });
    return out.map(function (o) { return { label: o.from === o.to ? o.from : o.from + "–" + o.to, price: o.price }; });
  }
  // The cheapest group (PLAN 6.4 change 2): the catalog builder's "from" rule, so Shopify, Liquid and JS agree.
  var basePrice = function (sizes, prices) { return Math.min.apply(null, sizeGroups(sizes, prices).map(function (g) { return g.price; })); };

  // ---- helpers named in the contract (CONTRACT 10.3) ----
  var fromDec = function (embOnly) {
    need();
    return embOnly ? { method: "emb", size: T.from.emb } : { method: "print", spots: [T.from.print_colors] };
  };
  var fromDeco = function (embOnly) { return decoAt(fromDec(embOnly), tierOf(need().from.qty)); };
  function ladder(gp, dec) {
    need();
    var a = [0, 1, 2, 3].filter(function (i) { return i < T.tiers.length; })
      .map(function (i) { return { min: T.tiers[i].min, each: eachAt(gp, dec, T.tiers[i].min) }; });
    return a.filter(function (r, k) { return k === 0 || r.each < a[k - 1].each; });
  }
  // min..10000: the 5,000+ break (since 2026-10-28) must be reachable, with room above it. The minimum is the price
  // tables' min_qty (15 since 2026-10-29; it was a fixed 12).
  var MAX_QTY = 10000;
  var minQty = function () { return (need().min_qty | 0) || 15; };
  var clampQty = function (q) { var n = Math.floor(+q || 0), lo = minQty(); return n < lo ? lo : n > MAX_QTY ? MAX_QTY : n; };
  // Names & numbers (PLAN 14.1): "none" | "names" | "numbers" | "both" -> dollars per piece. Print only.
  var nnAt = function (nn) {
    var t = need().nn || { name: 0, number: 0 };
    return nn === "names" ? t.name : nn === "numbers" ? t.number : nn === "both" ? c2(t.name + t.number) : 0;
  };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  var NN_WORDS = { names: " + names", numbers: " + numbers", both: " + names and numbers" };
  // "2-color front + 1-color back" / "small embroidery" (+ names & numbers on print), as gen-price's terms.
  function decoWords(dec, nn) {
    if (dec.method === "emb") return dec.size + " embroidery";
    var s = dec.spots || [], w = [];
    ["front", "back", "sleeve"].forEach(function (nm, k) { if (s[k] > 0) w.push(Math.min(s[k], 6) + "-color " + nm); });
    return (w.join(" + ") || "no print") + (NN_WORDS[nn] || "");
  }

  // The state gen-price reads, with its defaults: gp (dollars, = vcents - from_deco), embOnly, method,
  // spots [front, back, sleeve] (default [2, 0, 0]), size, q (50), sel (1), nouns ("pieces"), color, nn.
  function norm(st) {
    st = st || {};
    var clamp = function (x, dflt) { var n = x == null || x === "" ? dflt : Math.floor(+x) || 0; return Math.max(0, Math.min(6, n)); };
    var sp = st.spots || [];
    var embOnly = st.embOnly === true || st.embOnly === "true";
    var method = embOnly || st.method === "emb" ? "emb" : "print";
    var size = st.size === "large" ? "large" : "small";
    var spots = [clamp(sp[0], 2), clamp(sp[1], 0), clamp(sp[2], 0)];
    var nn = method === "print" && NN_WORDS[st.nn] ? st.nn : "none";
    return {
      gp: +st.gp, embOnly: embOnly, method: method, size: size, spots: spots, nn: nn,
      q: st.q == null || st.q === "" ? 50 : +st.q, sel: st.sel == null || st.sel === "" ? 1 : +st.sel,
      nouns: st.nouns == null || st.nouns === "" ? "pieces" : String(st.nouns),
      color: st.color == null ? "" : String(st.color),
      dec: method === "emb" ? { method: "emb", size: size } : { method: "print", spots: spots }
    };
  }

  // HTML / text identical to gen-price.liquid for the same state. Price modes return "" when gp < 1 cent.
  function view(mode, st) {
    need();
    var s = norm(st), out = "";
    if (mode === "v") return T.v;
    if (mode === "from_deco") return String(Math.round(fromDeco(s.embOnly) * 100));
    if (mode === "nn_cents") return String(Math.round(nnAt(st && st.nn) * 100));
    if (mode === "nn_money") return money(nnAt(st && st.nn));
    if (!(Math.round(s.gp * 100) >= 1)) return "";
    var g = c2(s.gp + nnAt(s.nn)), dec = s.dec, ti = tierOf(s.q), each = eachAt(g, dec, s.q);
    // no spot with colors: nothing that prices the current decoration (the board, ladder and footnote never use it)
    var priced = isFinite(each);
    if (!priced && ["each", "total", "second", "terms", "headline", "strip", "cliff"].indexOf(mode) >= 0) return "";
    var terms = qtyText(s.q) + " " + esc(s.nouns) + " · " + esc(decoWords(dec, s.nn)) + (s.color !== "" ? " · " + esc(s.color) : "") +
      " · " + (s.method === "emb" ? "embroidery" : "printing") + " included";
    var second = ti === 0
      ? tierLabel(1) + " " + esc(s.nouns) + ": " + money(eachAt(g, dec, T.tiers[1].min)) + " each"
      : tierLabel(0) + " " + esc(s.nouns) + ": " + money(eachAt(g, dec, T.tiers[0].min)) + " each";
    var cls = function (n, x) { return "c" + (x ? " x" : "") + (n === s.sel ? " sel" : ""); };
    var row = function (i) { return '<tr data-tier="' + i + '"' + (i === ti ? ' class="on"' : "") + "><td>" + tierLabel(i) + "</td>"; };
    switch (mode) {
      case "each": return money(each);
      case "total": return money(c2(each * s.q));
      case "second": return second;
      case "terms": return terms;
      case "headline":
        return '<div class="bigprice" data-fdp-each>' + money(each) + " <small>each</small></div>" +
          '<div class="terms" data-fdp-terms>' + terms + "</div>" +
          '<p class="hint" data-fdp-second style="margin-top:4px">' + second + "</p>";
      case "strip":
        return T.tiers.map(function (t, i) {
          return '<button type="button" data-tmin="' + t.min + '" aria-pressed="' + (i === ti) + '"><span>' + tierLabel(i) +
            "</span><b>" + money(eachAt(g, dec, t.min)) + "</b></button>";
        }).join("");
      case "board-print":
        out = '<table class="ptable" data-fdp-board="print" data-fdp-v="' + T.v + '"><thead><tr><th>Pieces</th>';
        for (var n = 1; n <= 6; n++) out += '<th class="' + cls(n, n > 3) + '">' + n + " color" + (n > 1 ? "s" : "") + "</th>";
        out += "</tr></thead><tbody>";
        T.tiers.forEach(function (t, i) {
          out += row(i);
          for (var k = 1; k <= 6; k++) out += '<td class="' + cls(k, k > 3) + '">' + money(c2(s.gp + T.print[i][k - 1])) + "</td>";
          out += "</tr>";
        });
        return out + "</tbody></table>";
      case "board-emb":
        out = '<table class="ptable" data-fdp-board="emb" data-fdp-v="' + T.v + '"><thead><tr><th>Pieces</th>' +
          '<th class="' + cls(1) + '">Small</th><th class="' + cls(2) + '">Large</th></tr></thead><tbody>';
        T.tiers.forEach(function (t, i) {
          out += row(i) + '<td class="' + cls(1) + '">' + money(c2(s.gp + T.emb.small.per_piece[i])) + "</td>" +
            '<td class="' + cls(2) + '">' + money(c2(s.gp + T.emb.large.per_piece[i])) + "</td></tr>";
        });
        return out + "</tbody></table>";
      case "ladder":
        return ladder(s.gp, fromDec(s.embOnly)).map(function (r) { return r.min + "+ " + money(r.each); }).join(" · ");
      case "footnote":
        if (s.embOnly) return "";
        return "A " + T.from.print_colors + "-color front and a " + T.from.print_colors + "-color back on " + T.from.qty + " " +
          esc(s.nouns) + ": " + money(eachAt(s.gp, { method: "print", spots: [T.from.print_colors, T.from.print_colors] }, T.from.qty)) + " each.";
      case "cliff": {  // JS only (Liquid never prints it): the mockup's chip or next-break line
        var cl = cliff(g, dec, s.q);
        if (!cl) return "";
        return cl.chip
          ? '<button type="button" class="chip-cliff" data-to="' + cl.m + '">Order ' + qtyText(cl.m) + " instead: <b>" + money(cl.then) +
            " total, " + money(cl.save) + " less</b> than " + qtyText(s.q) + ".</button>"
          : '<div class="next-break">Next price break at ' + qtyText(cl.m) + ": " + money(cl.each) + " each.</div>";
      }
    }
    throw new Error("FDP.price.view: unknown mode " + mode);
  }

  var api = {
    ready: false, T: null, v: null,
    load: load, c2: c2, money: money, tierOf: tierOf, tierLabel: tierLabel, decoAt: decoAt, eachAt: eachAt, cliff: cliff,
    sizeGroups: sizeGroups, basePrice: basePrice, ladder: ladder, fromDeco: fromDeco, clampQty: clampQty, minQty: minQty, MAX_QTY: MAX_QTY,
    qtyText: qtyText,
    nnAt: nnAt, decoWords: decoWords, esc: esc, view: view
  };
  FDP.price = api;
  window.__fdpPrice = { eachAt: eachAt, cliff: cliff, tierOf: tierOf };
  load();
})();
